import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
      },
    {
        title:Util.L('PackageNo'),
        key:'packageNo'
    },
    {
        title:Util.L('RefType'),
        key:'refTypeName',
        align:"center",
        width: 120
    },
    {
        title:Util.L('RefCode'),
        key:'refCode'
    },
   
    {
        title:Util.L('ExternalCode'),
        key:'externalCode'
    },
    {
        title:Util.L('CustomerName'),
        key:'customerName',
    }, 
    {
        title:Util.L('HandoverTime'),
        key:'handoverTime',
        render:(h:any,params:any)=>{
            if(Util.isNull(params.row.handoverTime))
              return h("span", "");
            return h("span", Util.toViewDateString(params.row.handoverTime));
        }
    }]